var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('PageTitle',{attrs:{"title":"Námsráðgjöf"}}),_c('PageMenu',{attrs:{"route":"Counseling","selectedPage":_vm.page,"items":_vm.menu}}),(_vm.page === 'interviews')?_c('Interviews'):_vm._e(),(_vm.page === 'overview')?_c('Overview'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }